<template>
  <div>
    <card id="gatewayFileExplorer" no-header no-footer>
      <div slot="card-body">
        <breadcrumb />

        <div class="fe-container">
          <div class="fe-left-panel">
            <div class="fe-scroll">
              <tree :gateway="gateway" />
            </div>
          </div>

          <div class="fe-right-panel">
            <explorer />
            <informations />
          </div>
        </div>
      </div>
    </card>

    <div class="alert alert-info">
      {{ $t('g-fileExplorer:info') | capitalize }}
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Breadcrumb from './Breadcrumb'
import Tree from './Tree'
import Explorer from './Explorer'
import Informations from './Informations'

export default {
  titleKey: 'gatewayFileExplorer',

  components: { Breadcrumb, Tree, Explorer, Informations },

  props: {
    eui: {
      type: String,
      default: ''
    }
  },

  data () {
    return {
      eventBus: null
    }
  },

  computed: {
    ...mapGetters(['gateway'])
  },

  watch: {
    eui () {
      // Reset data, and get data from new gateway
      this.$store.commit('resetStore')
    }
  },

  destroyed () {
    this.$store.commit('resetStore')
  }
}
</script>

<style scoped lang="scss">
  @import "~@/scss/variables";

  .fe-container {
    display: flex;
    height: 700px;

    .fe-scroll {
      height: 100%;
      overflow: auto;

      & > ul {
        height: 100%;
      }
    }

    .fe-left-panel {
      width: 25%;
      background-color: $gray-300;
    }

    .fe-right-panel {
      width: calc(75% - 15px);
      margin-left: 15px;
    }

    .fe-main-menu {
      margin-bottom: 10px;
    }
  }
</style>
